// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__6jFf+","title":"style__title__VtTw2","description":"style__description__LzmbR","component":"style__component__aYkdI"};